import { TutorialStep } from '../models/TutorialStep';

export const TUTORIAL_STEPS = [
  new TutorialStep({
    id: 'responsibility-card',
    targetSelector: '.responsibility-card:first-child',
    message: 'This card represents one of your work responsibilities',
    buttonText: 'OK',
    advanceOn: 'button',
    route: '/home',
    preferPlacement: 'above',
    analyticsEvent: 'tutorial_step_responsibility_card',
  }),
  new TutorialStep({
    id: 'prompt-title',
    targetSelector: '.responsibility-card:first-child .responsibility-prompt-title',
    message: 'This is the title of one of your prompts, click it to go to the prompt details',
    buttonText: null,
    advanceOn: 'natural-click',
    route: '/home',
    analyticsEvent: 'tutorial_step_prompt_title',
  }),
  new TutorialStep({
    id: 'copy-button',
    targetSelector: '[data-tutorial-target="copy-button"]',
    message: 'This page details what the prompt is with the text ready to copy. Click the copy button to copy that prompt, then you can use it in your GenAI tool of choice',
    buttonText: 'Got it',
    advanceOn: 'button',
    route: '/prompt/',
    navigateAfter: '/home',
    analyticsEvent: 'tutorial_step_copy_button',
  }),
  new TutorialStep({
    id: 'discover-tab',
    targetSelector: '[data-tutorial-target="discover-tab"]',
    message: "Click on this tab. Here you can see all the prompts available to you, some created by the Framework team, others created by people in your organisation",
    buttonText: null,
    advanceOn: 'natural-click',
    route: '/home',
    analyticsEvent: 'tutorial_step_discover_tab',
  }),
  new TutorialStep({
    id: 'search-input',
    targetSelector: '[data-tutorial-target="search-input"]',
    message: 'Here you can search for any prompt you want',
    buttonText: 'Got it',
    advanceOn: 'button',
    route: '/home',
    analyticsEvent: 'tutorial_step_search',
  }),
];
